<template>
  <div
    id="main-wrapper"
    class="hideLeftSidebar"
    :class="{ 'main-wrapper': user != null }"
  >
    <headers
      v-if="$store.getters._isAuthenticated && isConfirmLogin && isLoadApp"
    ></headers>
    <load-area class="full" v-if="!isLoadApp"></load-area>
    <div
      class="page-wrapper container-fluid"
      :class="{ 'p-0': $route.name == 'Login' }"
    >
      <router-view v-if="isConfirmLogin && isLoadApp"></router-view>
    </div>
    <projectMonitoring v-if="isDevelopment"></projectMonitoring>
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import projectMonitoring from "@/components/projectMonitoring.vue";
import { mapState, mapMutations } from "vuex";
import Toastify from "toastify-js";
export default {
  name: "App",
  components: { headers, projectMonitoring },
  data() {
    return {
      dancerShow: true,
      isConfirmLogin: true,
      isLoadApp: false,
      waitOnlineReservations: null,
    };
  },
  watch: {
    $route() {
      try {
        if (window.mmenu != undefined) {
          window.mmenu.close();
        }
      } catch (error) {
        console.log(error);
      }
      document
        .querySelectorAll(".mm-page__blocker.mm-slideout")
        .forEach((element) => {
          element.click;
        });
      if (this.routes[this.$route.path] != undefined) {
        this.addTabItem(this.routes[this.$route.path]);
      } else if (
        this.tabs.components.filter((x) => {
          return x.url == this.$route.path;
        }).length == 0
      ) {
        Object.entries(this.routes)
          .filter((x) => {
            return this.$route.path.indexOf(x[1].url) > -1;
          })
          .forEach((element) => {
            this.addDirectTabItem({ ...element[1], url: this.$route.path });
          });
      } else {
        if (
          this.tabs.components.filter((x) => {
            return x.url == this.$route.path;
          }).length > 0
        ) {
          this.$store.state.tabs.selected = this.tabs.components.filter((x) => {
            return x.url == this.$route.path;
          })[0].uid;
        }
      }
    },
  },
  created() {
    document.title = "NAPS ADMIN";
    this.create();
    this.$store._state.data.requestWatch = {};
    // console.log(
    //   "this.$appAxios",
    //   Object.keys(this.$appAxios.interceptors.request)
    // );

    // this.$appAxios.interceptors.request.use(
    //   function(config) {
    //     console.log("interceptors", config);
    //     return config;
    //   },
    //   function(error) {
    //     // Yanıttaki hata ile bir şey yap
    //     return Promise.reject(error);
    //   }
    // );
    // this.$appAxios.interceptors.response.use(
    //   function(config) {
    //     console.log("interceptors", config);
    //     return config;
    //   },
    //   function(error) {
    //     // Yanıttaki hata ile bir şey yap
    //     return Promise.reject(error);
    //   }
    // );
  },
  methods: {
    ...mapMutations(["addTabItem", "addDirectTabItem"]),
    create() {
      this.isLoadApp = true;
      this.isConfirmLogin = true;
      this.confirmLogin();
    },
    confirmLogin(){
          this.$appAxiosOther
            .get(`https://api.kolayrez.com/auth/confirmtoken`, {
      headers: { Authorization: this.$store.state.user?.Token },
    }).then(r=>{
      let response={ReturnObject:r.data};
       this.$appAxios.defaults.headers.Authorization =
                response.ReturnObject.Token;
              this.$appAxiosAdmin.defaults.headers.Authorization =
                response.ReturnObject.Token;
              this.$appAxiosTourscope.defaults.headers.Authorization =
                response.ReturnObject.Token;
              this.$store.commit("setUser", response.ReturnObject);
              if (location.hash.toUpperCase() == "#/LOGIN") {
                this.$router.push({ name: "Home" });
              }
            this.isLoadApp = true;
            this.isConfirmLogin = true;
    }).catch(()=>{
              this.$store.commit("setUser", null);
              this.$router.push({ name: "Login" });
            this.isLoadApp = true;
            this.isConfirmLogin = true;
    })
    },
    exchangeCurrency: async (
      currency,
      currentCode,
      price,
      exchange,
      baseCode = "RUB"
    ) => {
      try {
        var exchangePrice = price;
        if (exchange != currentCode) {
          if (currentCode != baseCode) {
            exchangePrice = exchangePrice * currency[baseCode];
          }
          exchangePrice = exchangePrice / currency[exchange];
        }
        return parseFloat(exchangePrice.toFixed(2));
      } catch {
        return price;
      }
    },
    getWaitRezervation() {
      if (this.user != null) {
        this.$appAxiosAdmin.get(`KOLAYREZ/Reservations`).then((response) => {
          this.waitOnlineReservations = response.data;
          document.title =
            this.waitOnlineReservations.Rows.length + " Bekleyen Rezervasyon";
        });
      }
    },
    // silentSuccess: cagiran taraf kendi yerinde geri bildirimini gosteriyorsa
    // (or. dugmenin uzerinde tik) basari toast'i bastirilir - ikisi birden
    // gurultu olur. HATA toast'i her durumda cikar, cunku sebebi ("https
    // gerekiyor" gibi) bir dugmeye sigmaz.
    clipboardCopy(text, silentSuccess) {
      // Onceden hicbir geri bildirim yoktu: 13 cagri noktasinda kullanici
      // kopyalandi mi bilmiyordu. Ayrica writeText bir Promise dondurur ve
      // navigator.clipboard HTTP'de (guvensiz baglam) TANIMSIZDIR -> guard
      // olmadan TypeError atiyordu ve gene sessiz kaliyordu.
      // Toast ayarlari store.js:502'deki mevcut konvansiyonla ayni.
      const toast = (msg, bg) =>
        Toastify({
          text: msg,
          duration: 1800,
          gravity: "bottom",
          position: "right",
          stopOnFocus: true,
          style: { background: bg },
        }).showToast();
      if (!navigator.clipboard) {
        toast("Kopyalanamadı — https bağlantısı gerekiyor", "#c53030");
        return Promise.resolve(false);
      }
      return navigator.clipboard.writeText(text).then(
        () => {
          // Proje rengi mavi (colors/blue.css) -> basari toast'i da mavi.
          if (!silentSuccess) toast("Kopyalandı", "#1e88e5");
          return true;
        },
        (err) => {
          console.error("clipboardCopy basarisiz:", err);
          toast("Kopyalanamadı", "#c53030");
          return false;
        }
      );
    },
  },
  computed: {
    ...mapState([
      "user",
      "routes",
      "tabs",
      "leftSidebarShow",
      "tabsClicked",
      "muteAlarm",
      "notifications",
    ]),
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
  },
};
</script>
<style>
@import "./assets/plugins/bootstrap/css/bootstrap.min.css";
/* @import "./assets/plugins/chartist-js/dist/chartist.min.css";
@import "./assets/plugins/chartist-js/dist/chartist-init.css";
@import "./assets/plugins/chartist-plugin-tooltip-master/dist/chartist-plugin-tooltip.css"; */
@import "./assets/plugins/c3-master/c3.min.css";
@import "./assets/plugins/toast-master/css/jquery.toast.css";
@import "./assets/plugins/sweetalert/sweetalert.css";
@import "./assets/css/style.css";
@import "./assets/plugins/bootstrap-material-datetimepicker/css/bootstrap-material-datetimepicker.css";
@import "./assets/plugins/daterangepicker/daterangepicker.css";
@import "./assets/css/colors/blue.css";
@import "./assets/css/mmenu.css";
/* @import "./assets/plugins/Magnific-Popup-master/dist/magnific-popup.css"; */
@import "./assets/plugins/wizard/steps.css";
@import "./assets/plugins/css-chart/css-chart.css";
@import "./assets/css/custom.css?v13";
</style>
